import React from 'react';
import Method from "../components/Method";
import Attributes from "../components/Attributes";
import Layout from "../layout";

const CourierObject = (props) => {
    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Couriers </h1>
                    <br/>
                    <p>Biteship partner with multiple couriers around the region. You can find list of available
                        couriers with this <b>Couriers API</b>. This API can help you to choose which courier that suits
                        your needs.
                    </p>
                    <br/>
                    <Method title={"ENDPOINTS"} white>
                        <a href="/docs/api/couriers/list" className="text-decoration-none">
                            <p className="text-black-50"><b className="text-primary">GET</b> /v1/couriers</p>
                        </a>
                    </Method>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">The courier object</h2>
                    <br/>
                    <p>List of all attributes in the courier object</p>
                    <Attributes data={attributes}/>
                </div>
            </div>
            <br/>
            <br/>
        </Layout>
    )
};

const attributes = [{
    name:'courier_name',
    type:'string',
    description:'Brand name for the courier'
},{
    name:'courier_code',
    type:'string',
    description:'Unique for the courier'
},{
    name: 'courier_service_name',
    type: 'string',
    description: 'The commercial name of the service  '
},{
    name: 'courier_service_code',
    type: 'string',
    description: 'The code of the courier service'
},{
    name: 'description',
    type: 'string',
    description: 'Additional information for the courier'
},{
    name: 'service_type',
    type: 'string',
    description: 'Service category for the courier'
},{
    name: 'shipping_type',
    type: 'string',
    description: 'Mode of transportation use for the shipments'
},{
    name: 'shipment_duration_range',
    type: 'string',
    description: `Time of delivery based on courier's SLA`
},{
    name: 'shipment_duration_unit',
    type: 'string',
    description: 'The unit of the delivery time'
}]

export default CourierObject
